module.exports = require("././angular-translate-loader-static-files.js");


//////////////////
// WEBPACK FOOTER
// angular-translate-loader-static-files (bower component)
// module id = 379
// module chunks = 1